<template>
  <b-row no-gutters class="flex-column flex-md-row">
    <b-col class="mb-3 mb-md-0 pr-0 pr-md-4">
      <Search />
    </b-col>
    <b-col class="mb-3 mb-md-0 pr-0 pr-md-4">
      <FilterBy />
    </b-col>
    <b-col>
      <SortBy />
    </b-col>
  </b-row>
</template>

<script>
import Search from "./filters/Search.vue";
import FilterBy from "./filters/FilterBy.vue";
import SortBy from "./filters/SortBy.vue"

export default {
  components: { Search, FilterBy, SortBy }
}
</script>
